export default __webpack_public_path__ + "5055a1dac646fc8a9a0aee0b04b42687.png";